import React from "react";
import EquipamentTemplate from "../../componentes/templates/Equipment";

export default function Bloc() {
  return (
    <EquipamentTemplate />
  );
}
